import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  ActivityIndicator,
  Modal,
} from 'react-native';
import api from '../services/api';

const Sortear = ({ route, navigation }) => {
  const [numeroUm, setNumeroUm] = useState('');
  const [numeroDois, setNumeroDois] = useState('');
  const [numeroTres, setNumeroTres] = useState('');
  const [numeroQuatro, setNumeroQuatro] = useState('');

  const [cartelas, setCartelas] = useState([]);
  const [ganhador, setGanhador] = useState(null);
  const [sorteioAtivo, setSorteioAtivo] = useState(true);
  const [loading, setLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [finalizando, setFinalizando] = useState(false);

  const [sorteioInfo, setSorteioInfo] = useState({
    id: '',
    nome: '',
    cidade: '',
  });

  useEffect(() => {
    const dados = route.params;
    setSorteioInfo({
      id: dados.id,
      nome: dados.nome,
      cidade: dados.cidade?.nome || '',
    });
    carregarCartelas(dados.id);
  }, []);

  const carregarCartelas = useCallback(async (sorteioId) => {
    try {
      setLoading(true);
      const { data } = await api.get(`sorteios/${sorteioId}/cartelas`);

      const cartelasVendidas = data
        .filter((c) => c.cliente_id !== null)
        .map((c) => ({
          id: c.id,
          numeros: c.numeros,
          cliente: c.cliente.nome,
          vendedor: c.vendedor.nome,
        }));

      setCartelas(cartelasVendidas);
    } catch (error) {
      console.error('Erro ao carregar cartelas:', error);
      alert('Erro ao carregar cartelas do sorteio');
    } finally {
      setLoading(false);
    }
  }, []);

  const numeroDigitado = useMemo(() => {
    return numeroUm + numeroDois + numeroTres + numeroQuatro;
  }, [numeroUm, numeroDois, numeroTres, numeroQuatro]);

  const possiveis = useMemo(() => {
    if (numeroDigitado.length === 0) {
      return cartelas;
    }

    return cartelas.filter((cartela) =>
      cartela.numeros.some((numero) => numero.startsWith(numeroDigitado))
    );
  }, [numeroDigitado, cartelas]);

  useEffect(() => {
    if (numeroDigitado.length === 4 && sorteioAtivo) {
      const cartelaGanhadora = possiveis.find((cartela) =>
        cartela.numeros.includes(numeroDigitado)
      );

      setGanhador(cartelaGanhadora || null);
      setSorteioAtivo(false);
    }
  }, [numeroDigitado, possiveis, sorteioAtivo]);

  const finalizarSorteio = useCallback(async () => {
    try {
      setFinalizando(true);
      await api.patch(`sorteios/${sorteioInfo.id}/finalizar`, {
        numero_sorteado: numeroDigitado,
      });

      setModalVisible(true);
    } catch (error) {
      console.error('Erro ao finalizar:', error);
      alert('Falha ao finalizar sorteio');
      setFinalizando(false);
    }
  }, [sorteioInfo.id, numeroDigitado]);

  const handleRepetirSorteio = useCallback(async () => {
    try {
      setModalVisible(false);
      setFinalizando(true);
      await api.post(`sorteios/${sorteioInfo.id}/clonar`);

      setTimeout(() => {
        navigation.reset({
          index: 0,
          routes: [{ name: 'Tabs' }],
        });
      }, 500);
    } catch (error) {
      console.error('Erro ao clonar sorteio:', error);
      alert('Erro ao criar novo sorteio');
      navigation.reset({
        index: 0,
        routes: [{ name: 'Tabs' }],
      });
    }
  }, [sorteioInfo.id, navigation]);

  const handleNaoRepetir = useCallback(() => {
    setModalVisible(false);
    navigation.reset({
      index: 0,
      routes: [{ name: 'Tabs' }],
    });
  }, [navigation]);

  if (loading) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <ActivityIndicator size="large" color="#1abc9c" />
        <Text style={{ marginTop: 10, color: '#7f8c8d' }}>
          Carregando cartelas...
        </Text>
      </View>
    );
  }

  return (
    <View style={{ flex: 1 }}>
      <View style={{ margin: 20, flex: 1 }}>
        <View
          style={{
            backgroundColor: '#fff',
            padding: 10,
            marginTop: 10,
            borderRadius: 5,
          }}
        >
          <View style={{ flexDirection: 'row' }}>
            <Text style={{ flex: 1, fontWeight: 'bold' }}>
              {sorteioInfo.nome}
            </Text>
            <Text>{sorteioInfo.cidade}</Text>
          </View>

          {sorteioAtivo ? (
            <View style={{ marginTop: 10 }}>
              <Text style={{ fontWeight: 'bold', textAlign: 'center' }}>
                Possíveis ganhadores
              </Text>
              <Text style={{ textAlign: 'center' }}>{possiveis.length}</Text>
            </View>
          ) : (
            <View style={{ marginTop: 10 }}>
              <Text style={{ fontWeight: 'bold', textAlign: 'center' }}>
                Sorteio finalizado
              </Text>
              <Text style={{ textAlign: 'center' }}>
                {ganhador
                  ? `${ganhador.cliente} (${ganhador.vendedor})`
                  : 'Nenhum ganhador'}
              </Text>
            </View>
          )}
        </View>

        <View
          style={{
            backgroundColor: '#fff',
            padding: 10,
            marginTop: 10,
            borderRadius: 5,
          }}
        >
          <View style={{ flexDirection: 'row' }}>
            <View style={{ flex: 1 }}>
              <TextInput
                editable={sorteioAtivo}
                maxLength={1}
                value={numeroUm}
                onChangeText={setNumeroUm}
                keyboardType="number-pad"
                style={{
                  marginTop: 10,
                  backgroundColor: '#ecf0f1',
                  color: '#34495e',
                  borderRadius: 5,
                  height: 50,
                  margin: 5,
                  fontSize: 20,
                  textAlign: 'center',
                }}
              />
            </View>
            <View style={{ flex: 1 }}>
              <TextInput
                editable={sorteioAtivo}
                maxLength={1}
                value={numeroDois}
                onChangeText={setNumeroDois}
                keyboardType="number-pad"
                style={{
                  marginTop: 10,
                  backgroundColor: '#ecf0f1',
                  color: '#34495e',
                  borderRadius: 5,
                  height: 50,
                  margin: 5,
                  fontSize: 20,
                  textAlign: 'center',
                }}
              />
            </View>
            <View style={{ flex: 1 }}>
              <TextInput
                editable={sorteioAtivo}
                maxLength={1}
                value={numeroTres}
                onChangeText={setNumeroTres}
                keyboardType="number-pad"
                style={{
                  marginTop: 10,
                  backgroundColor: '#ecf0f1',
                  color: '#34495e',
                  borderRadius: 5,
                  height: 50,
                  margin: 5,
                  fontSize: 20,
                  textAlign: 'center',
                }}
              />
            </View>
            <View style={{ flex: 1 }}>
              <TextInput
                editable={sorteioAtivo}
                maxLength={1}
                value={numeroQuatro}
                onChangeText={setNumeroQuatro}
                keyboardType="number-pad"
                style={{
                  marginTop: 10,
                  backgroundColor: '#ecf0f1',
                  color: '#34495e',
                  borderRadius: 5,
                  height: 50,
                  margin: 5,
                  fontSize: 20,
                  textAlign: 'center',
                }}
              />
            </View>
          </View>
        </View>

        {!sorteioAtivo && (
          <TouchableOpacity
            style={{ marginTop: 25 }}
            onPress={finalizarSorteio}
            disabled={finalizando}
          >
            <Text
              style={{
                backgroundColor: finalizando ? '#95a5a6' : '#1abc9c',
                color: '#fff',
                textAlign: 'center',
                padding: 7.5,
                borderRadius: 5,
              }}
            >
              {finalizando ? 'Finalizando...' : 'Finalizar'}
            </Text>
          </TouchableOpacity>
        )}
      </View>

      {/* Modal de Confirmação */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => setModalVisible(false)}
      >
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          }}
        >
          <View
            style={{
              backgroundColor: '#fff',
              borderRadius: 10,
              padding: 25,
              width: '80%',
              maxWidth: 400,
              shadowColor: '#000',
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.25,
              shadowRadius: 4,
              elevation: 5,
            }}
          >
            <Text
              style={{
                fontSize: 20,
                fontWeight: 'bold',
                textAlign: 'center',
                marginBottom: 10,
                color: '#27ae60',
              }}
            >
              Sorteio Finalizado!
            </Text>

            <Text
              style={{
                fontSize: 16,
                textAlign: 'center',
                marginBottom: 20,
                color: '#34495e',
              }}
            >
              Deseja criar um novo sorteio idêntico a este?
            </Text>

            <View style={{ flexDirection: 'row', gap: 10 }}>
              <TouchableOpacity
                style={{
                  flex: 1,
                  backgroundColor: '#95a5a6',
                  padding: 12,
                  borderRadius: 5,
                }}
                onPress={handleNaoRepetir}
              >
                <Text
                  style={{
                    color: '#fff',
                    textAlign: 'center',
                    fontWeight: 'bold',
                  }}
                >
                  Não
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                style={{
                  flex: 1,
                  backgroundColor: '#1abc9c',
                  padding: 12,
                  borderRadius: 5,
                }}
                onPress={handleRepetirSorteio}
              >
                <Text
                  style={{
                    color: '#fff',
                    textAlign: 'center',
                    fontWeight: 'bold',
                  }}
                >
                  Sim, Repetir
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
};

export default Sortear;
